<div class="p-no-permission-container">
  <img src="./assets/images/sigv-library/img-404.svg" alt="No permission" />
  <p>{{ "SigvLibrary.NoPermission" | translate }}</p>
  <button
    pButton
    type="button"
    label="{{ 'SigvLibrary.Home' | translate }}"
    class="p-button-secondary p-content-button p-mr-1"
    (click)="goHome()"
  ></button>
</div>
